module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/car-park-icon-5b05acf678aae63507febdd0f0762302.png";